import styled from "styled-components";
import React, {useEffect, useState} from "react";
import {
  CancelButton,  ColSpan3,
  ColTitle,
  Input,
  RelativeDiv,
  RowSpan,
  Span4,
  ValidationScript,
} from "../../assets/GlobalStyles";
import {useAtom} from "jotai";
import {useForm} from "react-hook-form";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import {modalController} from "../../store";
import {updateAdmin} from "../../services/platform/ManageAdminAxios";

export default function SelectAdminModal(props) {
  const {formType, title, onClick, buttonText, userId, data} = props;
  const [, setModal] = useAtom(modalController)
  useEffect(()=>{
    return ()=> {
      onClose()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  const onClose = () => {
    setModal({ isShow: false })
  }

  const handleModalComponent = () => {
    setModal({
      isShow: true,
      width: 900,
      modalComponent: () => {
        return (
          <SelectForm formType={formType} title={title} onSubmitProps={onClick} onClose={onClose} userId={userId} data={data}/>
        )
      }
    })
  }
  return (
      <Button type={'button'} onClick={handleModalComponent}>{buttonText}</Button>
  )
}

function SelectForm(props) {
  const {title, onClose, data, onSubmitProps} = props;
  const [adminInfoState, setAdminInfoState] = useState(data || {});

  const {register, handleSubmit, formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: data || {},
  });
  useEffect(()=>{
    if(data) {
      setAdminInfoState(data);
    }
  },[data])

  const onError = (error) => console.log(error);
  const handleSave = async () => {
    const saved = await updateAdmin({
      ...adminInfoState,
      activeYn: adminInfoState.status === "NORMAL" ? "Y" : "N"
    });
    if (saved) {
      onSubmitProps?.(adminInfoState);
      onClose();
    }
  };
  /**
   * 아이디 입력
   * @param event
   */
  const handleAdminId = (event) => {
        setAdminInfoState({
          ...adminInfoState,
          email: event.target.value
        })
      }
  /**
   * 담당자명 입력
   * @param event
   */
  const handleManagerName = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      name: event.target.value
    })
  }
  /**
   * 담당자 연락처 입력
   * @param event
   */
  const handleManagerPhone = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      phoneNumber: event.target.value
    })
  }

  return (
      <AdminDetailForm onSubmit={handleSubmit(handleSave, onError)}>
        <ModalHeader title={title}/>
        <AdminModalBody>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>아이디</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                      type={'text'}
                      placeholder={'이메일 형태 아이디를 입력해주세요'}
                      disabled
                      value={adminInfoState.email || ""}
                      {...register("email", {
                        required: "관리자 아이디를 입력해주세요",
                      })}
                      onChange={(e) => handleAdminId(e)}
                  />
                  {errors.email && <ValidationScript>{errors.email?.message}</ValidationScript>}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자명</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                      type={'text'}
                      placeholder={'담당자 명을 입력해주세요'}
                      disabled
                      {...register("name", {
                        required: "담당자 명을 입력해주세요",
                      })}
                      value={adminInfoState.name || ""}
                      onChange={(e) => handleManagerName(e)}
                  />
                  {errors.name && <ValidationScript>{errors.name?.message}</ValidationScript>}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자 연락처</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                      type={'text'}
                      placeholder={'연락처를 입력해주세요.'}
                      disabled
                      {...register("phoneNumber", {
                        required: "담당자 연락처를 입력해주세요.",
                        pattern: {
                          value: /^[0-9-]+$/g,
                          message: "연락처를 형식을 확인해주세요"
                        },
                      })}
                      value={adminInfoState.phoneNumber || ""}
                      onChange={(e) => handleManagerPhone(e)}
                  />
                  {errors.phoneNumber && <ValidationScript>{errors.phoneNumber?.message}</ValidationScript>}
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>사용 여부</Span4></ColTitle>
                <StatusControl>
                  <StatusSelector
                    value={adminInfoState.status || "NORMAL"}
                    onChange={event=>setAdminInfoState(prev=>({
                      ...prev,
                      status:event.target.value,
                      activeYn:event.target.value==="NORMAL"?"Y":"N"
                    }))}
                  >
                    <option value="NORMAL">활성화</option>
                    <option value="SUSPEND">비활성화</option>
                  </StatusSelector>
                  <StatusDescription>비활성화된 관리자는 로그인할 수 없습니다.</StatusDescription>
                </StatusControl>
              </ColSpan3>
            </RowSpan>
        </AdminModalBody>
        <AdminModalFooter>
          <CancelButton type="button" onClick={onClose}>취소</CancelButton>
          <SaveButton type="submit">수정</SaveButton>
        </AdminModalFooter>
      </AdminDetailForm>
  )
}

const Button = styled.button`
  width: 100%;
  border-radius: 5px;
  font-size: var(--font-size-16);
  cursor: pointer;
  background-color: white;

  &:hover {
    font-weight: bold;
  }
`
const StatusControl=styled.div`display:flex;align-items:center;gap:12px;`;
const StatusSelector = styled.select`
  width:116px;height:42px;padding:0 34px 0 12px;border:1px solid #d8e0e8;border-radius:8px;
  background:var(--color-surface);color:#34404d;font-size: var(--font-size-13);font-weight:700;outline:0;cursor:pointer;
  &:focus{border-color:var(--color-primary);box-shadow:0 0 0 3px rgba(59,130,246,.1);}
`;
const StatusDescription=styled.span`color:#9aa3ad;font-size: var(--font-size-11);`;
const SaveButton = styled.button`
  min-width:110px;height:40px;border:1px solid var(--color-primary);border-radius:7px;
  background:var(--color-primary-soft);color:var(--color-primary-strong);font-size: var(--font-size-13);font-weight:700;cursor:pointer;
  &:hover{background:var(--color-primary-muted);}
`;
const AdminDetailForm=styled.form`
  overflow:hidden;border-top:3px solid var(--color-primary);border-radius:10px;background:var(--color-surface);
`;
const AdminModalBody=styled(ModalBody)`
  display:flex;flex-direction:column;gap:14px;padding:36px 34px 26px!important;
  background:var(--color-surface);

  ${RowSpan}{display:block!important;min-width:0;margin:0!important;padding:0!important;}
  ${ColSpan3}{
    display:grid!important;grid-template-columns:140px minmax(0,450px);width:100%!important;min-width:0;
    align-items:center!important;justify-content:start;gap:18px!important;
  }
  ${ColTitle}{margin:0!important;padding:0!important;color:#444;font-size: var(--font-size-13);font-weight:700;}
  ${ColTitle} span{width:auto!important;}
  ${Input}{
    width:100%;height:42px;box-sizing:border-box;padding:0 13px;border:1px solid #d8dee5!important;
    border-radius:6px!important;background:#f1f2f3!important;color:#444;font-size: var(--font-size-13);
  }
  @media(max-width:680px){
    padding:24px 20px!important;
    ${ColSpan3}{grid-template-columns:1fr;gap:7px!important;}
    ${StatusControl}{align-items:flex-start;flex-direction:column;}
  }
`;
const AdminModalFooter=styled(ModalFooter)`
  display:flex!important;justify-content:center!important;gap:8px;padding:16px 22px!important;
  border-top:1px solid var(--color-divider)!important;background:#f9fafb!important;

  ${CancelButton}{
    min-width:110px!important;height:40px!important;margin:0!important;border:1px solid #68717c!important;
    border-radius:7px!important;background:var(--color-surface)!important;color:#68717c!important;font-size: var(--font-size-13)!important;font-weight:650!important;
  }
`;
